// Enumerations
import { DevicesBreakpointsEnumeration } from '../../../../../enumerations/devices/devices-breakpoints.enumeration';
// Foundations
import { FontsExceptionsFoundationsThemes } from '../../commons/fonts-exceptions-foundations.themes';
const FoundationsKubitCobrandedRegularFontsOthersTheming = {
    font_avatarl: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_avatar_l,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_avatar_l,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_avatar_l,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_avatar_l,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_avatar_l,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_avatar_l,
        },
    },
    font_avatarms: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_avatar_ms,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_avatar_ms,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_avatar_ms,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_avatar_ms,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_avatar_ms,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_avatar_ms,
        },
    },
    font_inputcurrency: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_input_currency,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_input_currency,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_input_currency,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_input_currency,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsExceptionsFoundationsThemes.font_exception_size_paragraph_input_currency,
            line_height: FontsExceptionsFoundationsThemes.font_exception_line_height_paragraph_input_currency,
        },
    },
};
export { FoundationsKubitCobrandedRegularFontsOthersTheming };
//# sourceMappingURL=foundations-kubit-cobranded-regular-fonts-others.theming.js.map